import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBM_CUSTOM_05_Schema } from './M_TBM_CUSTOM_05_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** 작업허가서 조회 GetTbmCustomR3 (Global.urls.TBM) */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_TBM_CUSTOM_05_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['TBM', 'getTbmCustomR3', params],
    queryFn: () => apiRequest('post', Global.urls.TBM.getTbmCustomR3, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
